import { render, staticRenderFns } from "./event.datacard.vue?vue&type=template&id=17cca4de&scoped=true&"
import script from "./event.datacard.vue?vue&type=script&lang=js&"
export * from "./event.datacard.vue?vue&type=script&lang=js&"
import style0 from "./event.datacard.vue?vue&type=style&index=0&id=17cca4de&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17cca4de",
  null
  
)

export default component.exports